// Namespace "public" — fragment "openHoursBooking".
//
// Open hours (docs/booking-module/open-hours-design.md): the client picks a service, then
// one of the start times that service offers right now. Two client-facing facts are new
// with that model and have no older string to reuse:
//
// `booking.timeUnavailable` — 409 TIME_UNAVAILABLE: the start the client picked was taken
// by someone else (or stopped being offered) between the page showing it and the submit.
// The page brings the client back to the times, re-reads them, and says why in one line.
// The same sentence answers a restored draft whose time has gone in the meantime.
//
// `booking.heldByYou` — the badge on the one start `GET /api/availability` adds back for
// the buyer whose unpaid hold occupies it (`held_by_you`, reached through the hold token
// the page kept): it is hidden from everyone else, and clicking it resumes the payment.
export default {
  fr: {
    "booking.timeUnavailable": "Ce moment vient d'être pris. Choisissez-en un autre.",
    "booking.heldByYou": "Retenu pour vous — reprendre le paiement",
  },
  en: {
    "booking.timeUnavailable": "That time was just taken. Please pick another.",
    "booking.heldByYou": "Held for you — resume payment",
  },
  es: {
    "booking.timeUnavailable": "Ese horario acaba de ocuparse. Elige otro, por favor.",
    "booking.heldByYou": "Reservado para ti — reanudar el pago",
  },
};
